import React from 'react'

export default function XerjoffLogo() {
  return (
   <div className='w-100 flex justify-center'>
      <img src='/customizations/xerjoff/logo.png' className='xerjoff-logo logo' alt="Logo" />
      </div>
  )
}
